import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"

import Icon from "../global/icon"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const InfoWrapper = styled.div`
  background-color: var(--ice-grey);
`
const InfoContainer = styled.div`
  max-width: 1248px;
  margin: 0 auto;
  padding: 80px 48px;
  overflow: hidden;
  ${below.tablet`
  padding:64px 48px;
  `}
  ${below.mobile`
  padding: 48px 24px;
  `}

  h2 {
    margin-bottom: 32px;
    ${below.mobile`
    margin-bottom: 24px;
  `};
  }
  h3 {
    color: #2d3748;
    margin-bottom: 24px;
    ${below.mobile`
    margin-bottom:16px;
    `}
  }
  a {
    font-weight: 400;
    font-size: 20px;
    line-height: 28px;
    color: var(--alt-black);
    transition: 0.3s ease-in-out;
    :hover {
      color: var(--pacific-blue);
      text-decoration: underline;
      .insta-circle {
        stroke: #3c9dfd;

        fill: #3c9dfd;
      }

      .insta-path {
        fill: #3c9dfd;
      }

      .social-circle {
        stroke: #3c9dfd;
        fill: #3c9dfd;
      }
      .social-path {
        fill: #2d3748;
      }
    }
    .social {
      /* fill: black; */
      transition: 0.3s ease-in-out;
    }
    &.social {
      height: 40px;
      // margin-right: 24px;
      :last-of-type {
        // margin-right: 0px;
      }
    }
    ${below.mobile`
    font-size: 16px;
    `}
  }
`
const FlexContainer = styled.div`
  column-gap: 172px;
  display: flex;
  align-items: ${props => props.alignItems || "flex-start"};
  // margin: ${props => props.margin || 0};
  justify-content: ${props => props.justifyContent || "flex-start"};
  ${below.tablet`
  flex-direction: column;
  row-gap: 56px;
  `}
  &.social {
    column-gap: 24px;
    ${below.mobile`
      flex-direction: row;
    `}
  }

  .alt-city {
    column-gap: 32px;
    // margin: 0 0 0 32px;
    ${below.tablet`
      row-gap: 24px;
      // margin: 24px 0 0 0;
    `}
  }
`
const ContactMethods = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 56px;
`
const ContactMethod = styled.div`
  // margin-bottom: 72px;
  min-width: 288px;
  ${below.tablet`
  // margin-bottom:56px;
  `}

  a {
    display: block;
    &:nth-of-type(2) {
      margin-top: 8px;
      &.social {
        margin-top: 0;
      }
    }
  }

  .social {
    flex-direction: row;
  }

  .in-the-area {
    margin-bottom: 12px;
    ${below.mobile`
    margin-bottom:8px;
    `}
  }

  &.phone {
    // margin-right: 172px;
    // margin-bottom: 56px;
  }

  &.calendly {
    // margin-bottom: 56px;
  }

  &.social {
    // margin-bottom: 56px;
    // margin-right: 172px;
  }
  &.address {
    // margin-bottom: 0;
  }

  .calendly-link {
    &:hover {
      span {
        color: var(--pacific-blue);
        text-decoration: none;
      }
      .calendar-icon {
        stroke: var(--pacific-blue);
      }
    }
    display: flex;
    align-items: center;
    span {
      color: var(--alt-black);
      margin-right: 4px;
    }
    svg {
      width: 20px;
      height: 20px;
    }
  }
`
const InfoLabel = styled.h4`
  color: var(--grey);
  margin-bottom: 8px;
  ${below.mobile`
  margin-bottom: 0px;
  `}
`
const Address = styled.div`
  font-size: 20px;
  line-height: 28px;
  color: var(--alt-black);
  min-width: 264px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  margin-bottom: 16px;
  :hover {
    color: var(--pacific-blue);
    text-decoration: underline;
  }
  &:last-child {
    margin-bottom: 0px;
  }
  ${below.mobile`
    font-size: 16px;
    `}
`

const PhoneFlexContainer = styled.div`
  display: flex;
  ${below.mobile`
  flex-direction:column;
  `}
`

const PhoneTitleLinkContainer = styled.div`
  h4 {
    color: var(--grey);
    margin-bottom: 12px;
    ${below.mobile`
    margin-bottom:8px;
    `}
  }
  margin-right: 48px;
  &:last-of-type {
    margin-right: 0;
  }

  ${below.mobile`
  margin-right:0;
  margin-bottom:32px;
  &:last-of-type {
    margin-bottom:0;
  }
  `}
`

const ContactInfo = props => {
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    const isIOS =
      (/iPad|iPhone|iPod/.test(navigator.platform) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) &&
      !window.MSStream
    if (isIOS) {
      setIsIOS(true)
    }
  }, [])

  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "")
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3]
    }
    return phoneNumberString
  }

  return (
    <InfoWrapper>
      <InfoContainer>
        <h2 id="additional-contact">Other methods</h2>
        <ContactMethods>
          <FlexContainer className="phone-email">
            <ContactMethod className="phone">
              <h3>
                {props.theme === "team default"
                  ? "Give us a call."
                  : "Give me a call."}
              </h3>
              <PhoneFlexContainer>
                {props.email === "teamjohnston@atlanticbay.com" ? (
                  <>
                    <PhoneTitleLinkContainer>
                      <h4>Kerry</h4>
                      <a href={`tel:704-747-2170`}>
                        {formatPhoneNumber("704-747-2170")}
                      </a>
                    </PhoneTitleLinkContainer>
                    <PhoneTitleLinkContainer>
                      <h4>Ryan</h4>
                      <a href={`tel:336-687-5781`}>
                        {formatPhoneNumber("336-687-5781")}
                      </a>
                    </PhoneTitleLinkContainer>
                  </>
                ) : (
                  <>
                    <PhoneTitleLinkContainer>
                      <h4>
                        {props.favoredPhone === "mobile" ? "Mobile" : "Office"}
                      </h4>
                      <a href={`tel:${props.phone}`}>{props.phoneText}</a>
                    </PhoneTitleLinkContainer>
                    {props.office && props.mobile && (
                      <PhoneTitleLinkContainer>
                        <h4>
                          {props.favoredPhone === "mobile"
                            ? "Office"
                            : "Mobile"}
                        </h4>
                        <a href={`tel:${props.altPhone}`}>
                          {props.altPhoneText}
                        </a>
                      </PhoneTitleLinkContainer>
                    )}
                  </>
                )}
              </PhoneFlexContainer>
            </ContactMethod>
            <ContactMethod>
              <h3>Send an email.</h3>
              {props.email === "teamjohnston@atlanticbay.com" ? (
                <div>
                  <a href={`mailto:kerryjohnston@atlanticbay.com`}>
                    kerryjohnston@atlanticbay.com
                  </a>
                  <a href={`mailto:ryanjohnston@atlanticbay.com`}>
                    ryanjohnston@atlanticbay.com
                  </a>
                </div>
              ) : (
                <a href={`mailto:${props.email}`}>{props.email}</a>
              )}
            </ContactMethod>
          </FlexContainer>
          <FlexContainer>
            {props.facebook ||
            props.linkedin ||
            props.instagram ||
            props.zillow ? (
              <ContactMethod className="social">
                <h3>Connect on social.</h3>
                <FlexContainer className="social">
                  {props.facebook && (
                    <a
                      href={props.facebook}
                      className="social"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Icon
                        icon="facebook"
                        width={below.mobile ? "24px" : "32px"}
                      />
                    </a>
                  )}
                  {props.linkedin && (
                    <a
                      href={props.linkedin}
                      className="social"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Icon
                        icon="linkedin"
                        width={below.mobile ? "24px" : "32px"}
                      />
                    </a>
                  )}
                  {props.instagram && (
                    <a
                      href={props.instagram}
                      className="social"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Icon
                        icon="instagram"
                        width={below.mobile ? "24px" : "32px"}
                      />
                    </a>
                  )}
                  {props.zillow && (
                    <a
                      href={props.zillow}
                      className="social"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Icon
                        icon="zillow"
                        width={below.mobile ? "24px" : "32px"}
                      />
                    </a>
                  )}
                </FlexContainer>
              </ContactMethod>
            ) : null}

            {props.calendly && (
              <ContactMethod className="calendly">
                <h3>Get on the calendar.</h3>
                <a
                  href={props.calendly}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="calendly-link"
                >
                  <span>
                    {props.theme === "team default"
                      ? "View our calendar"
                      : "View my calendar"}
                  </span>
                  <Icon icon="calendar" />
                </a>
              </ContactMethod>
            )}
          </FlexContainer>

          {props.street && (
            <ContactMethod className="address">
              <h3>In the area?</h3>
              <FlexContainer>
                <div>
                  <InfoLabel className="in-the-area">
                    {props.slug === "mitchpayne"
                      ? "Serving the 30A markets"
                      : props.city}
                  </InfoLabel>
                  <a
                    href={
                      props.streetAddress &&
                      props.city &&
                      props.state &&
                      props.zip
                        ? isIOS
                          ? `http://maps.apple.com/?address=${props.streetAddress.replace(
                              /\s/g,
                              "+",
                            )},${props.city.replace(
                              /\s/g,
                              "+",
                            )},${props.state.replace(/\s/g, "+")}`
                          : `https://www.google.com/maps/search/?api=1&query=${props.streetAddress.replace(
                              /\s/g,
                              "+",
                            )},${props.city.replace(
                              /\s/g,
                              "+",
                            )},${props.state.replace(/\s/g, "+")}`
                        : isIOS
                          ? "http://maps.apple.com/?address=600+Lynnhaven+Parkway,Virginia+Beach,Virginia"
                          : "https://www.google.com/maps/place/Atlantic+Bay+Mortgage+Group/@36.8259918,-76.0685092,17z/data=!3m1!4b1!4m8!1m2!2m1!1satlantic+bay+mortgage+group!3m4!1s0x89baeab9514c932f:0xbaa2770cb5886c70!8m2!3d36.8259918!4d-76.0663205"
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Address>
                      {`${props.streetAddress}${
                        props.suite ? ", " + props.suite : ""
                      }`}
                      <br />
                      {`${props.city}, ${props.state} ${props.zip}`}
                    </Address>
                  </a>
                </div>
                {props.altCity && (
                  <div className="alt-city">
                    <InfoLabel>{props.altCity}</InfoLabel>
                    <a
                      href={
                        props.altStreetAddress &&
                        props.altCity &&
                        props.altState &&
                        props.altZip
                          ? isIOS
                            ? `http://maps.apple.com/?address=${props.altStreetAddress.replace(
                                /\s/g,
                                "+",
                              )},${props.altCity.replace(
                                /\s/g,
                                "+",
                              )},${props.altState.replace(/\s/g, "+")}`
                            : `https://www.google.com/maps/search/?api=1&query=${props.altStreetAddress.replace(
                                /\s/g,
                                "+",
                              )},${props.altCity.replace(
                                /\s/g,
                                "+",
                              )},${props.altState.replace(/\s/g, "+")}`
                          : isIOS
                            ? "http://maps.apple.com/?address=600+Lynnhaven+Parkway,Virginia+Beach,Virginia"
                            : "https://www.google.com/maps/place/Atlantic+Bay+Mortgage+Group/@36.8259918,-76.0685092,17z/data=!3m1!4b1!4m8!1m2!2m1!1satlantic+bay+mortgage+group!3m4!1s0x89baeab9514c932f:0xbaa2770cb5886c70!8m2!3d36.8259918!4d-76.0663205"
                      }
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Address>
                        {`${props.altStreetAddress}`}
                        <br />
                        {`${props.altCity}, ${props.altState} ${props.altZip}`}
                      </Address>
                    </a>
                  </div>
                )}
              </FlexContainer>
            </ContactMethod>
          )}
        </ContactMethods>
      </InfoContainer>
    </InfoWrapper>
  )
}

export default ContactInfo
